// ./src/config/serviceIntervalTypes.ts

export const SERVICE_INTERVAL_TYPES = {
  NONE: 0,
  MILEAGE: 1,
  DAYS: 2,
  MILEAGE_OR_DAYS: 3,
  MILEAGE_AND_DAYS: 4,
} as const;

export type ServiceIntervalType = 0 | 1 | 2 | 3 | 4;

export interface ServiceIntervalOption<T extends number> {
  value: T;
  label: string;
}

// ============================================
// Distance Units
// ============================================

export const SERVICE_INTERVAL_OPTIONS: ServiceIntervalOption<ServiceIntervalType>[] =
  [
    {
      value: SERVICE_INTERVAL_TYPES.NONE,
      label: "None",
    },
    {
      value: SERVICE_INTERVAL_TYPES.MILEAGE,
      label: "Mileage",
    },
    {
      value: SERVICE_INTERVAL_TYPES.DAYS,
      label: "Days",
    },
    {
      value: SERVICE_INTERVAL_TYPES.MILEAGE_OR_DAYS,
      label: "Mileage or Days",
    },
    {
      value: SERVICE_INTERVAL_TYPES.MILEAGE_AND_DAYS,
      label: "Mileage and Days",
    },
  ];

export const SERVICE_INTERVAL_MAP: Record<
  ServiceIntervalType,
  ServiceIntervalOption<ServiceIntervalType>
> = Object.fromEntries(
  SERVICE_INTERVAL_OPTIONS.map((opt) => [opt.value, opt])
) as Record<ServiceIntervalType, ServiceIntervalOption<ServiceIntervalType>>;

export const DEFAULT_SERVICE_INTERVAL: ServiceIntervalType =
  SERVICE_INTERVAL_TYPES.NONE;
